































































/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';
import SearchField from '@/components/SearchField.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import SearchIcon from 'mdi-vue/Magnify';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import TagInput from '@/components/TagInput.vue';
import FormInput from '@/components/FormInput.vue';
import Loader from '@/components/Loader.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import { api2 } from '@/libs/api';
import Checkbox from '@/components/Checkbox.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

import SearchRow from '@/components/SearchRow.vue';
import hasPermission from '@/libs/permission';
import numberFormat from '@/libs/numberFormat';
import Button from '@/components/Button.vue';
import Pagination from '@/components/Pagination.vue';
import Select from '@/components/Select.vue';
import { ValidationObserver } from 'vee-validate';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    AddIcon,
    Loader,
    SearchField,
    Select,
    SearchRow,
    TagInput,
    Table,
    SearchIcon,
    TableBody,
    Row,
    Header,
    Cell,
    Button,
    Pagination,
    FormInput,
    ActionPopup,
    ScrollbarWrapper,
    ValidationObserver,
    Checkbox,
  },
  methods: {
    numberFormat,
    hasPermission,
  },
})
export default class StagingForm extends Vue {
  title = 'Staging Form';
  titleDescription = 'Staging Form Description';
  templateCode = '';
  forms = [];
  searchParams: any = {};

  mounted() {
    this.getConf();
  }

  async getConf() {
    this.templateCode = this.$route.params.templateCode;
    const { data } = await api2.post(`/recon/stg/conf/${this.templateCode}`, {});
    this.title = data.headers.template_title;
    this.titleDescription = data.headers.template_description;
    this.forms = data.forms;
  }

  async submitForm() {
    this.getForm();
  }

  getForm() {
    console.log(JSON.stringify(this.searchParams));
    if (Object.keys(this.searchParams).length === 0) {
      alert('nggak ngapa2in');
    } else {
      Object.keys(this.searchParams).forEach((key, value) => {
        console.log(`${key} : ${value}`);
      });
    }
  }

  cancel() {
    this.$router.go(-1);
  }
}
